import { render, staticRenderFns } from "./RepublicArmy.vue?vue&type=template&id=a7c59646&scoped=true"
import script from "./RepublicArmy.vue?vue&type=script&lang=js"
export * from "./RepublicArmy.vue?vue&type=script&lang=js"
import style0 from "./RepublicArmy.vue?vue&type=style&index=0&id=a7c59646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c59646",
  null
  
)

export default component.exports